
  const CLOSERS = "#chat-delete-confirm-submit, #chat-delete-confirm-cancel, #chat-delete-confirm-close"

  export default {
    mounted() {
      this.modal = this.el.querySelector("el-dialog")

      this.onOpen = (event) => {
        if (event.target.closest("[data-confirm-delete]")) this.modal.setAttribute("open", "")
      }
      document.addEventListener("click", this.onOpen)

      this.el.addEventListener("click", (event) => {
        if (event.target.closest(CLOSERS)) this.modal.removeAttribute("open")
      })
    },

    destroyed() {
      document.removeEventListener("click", this.onOpen)
    }
  }
